<template>
  <div class="input">
    <input v-if="validationMethod === 'onBlur'" :id="inputId" :class="{error : validationError,
    upper : upperCase, shift : frontIcon}" @blur="getInput($event.target.value)" :type="type" v-model="inputValue" :readonly="readonly" :disabled="disabled" required>
    <input v-else-if="validationMethod === 'onChange'" :id="inputId" :class="{error : validationError,
    upper : upperCase}" @blur="getInput($event.target.value)" :type="type" v-model="inputValue" :readonly="readonly" :disabled="disabled" required>
    <i class="frontIcon" v-if="frontIcon" :class="frontIcon"></i>
    <i :class="[icon, tooltip ? 'backIcon2' : 'backIcon']" v-if="icon"></i>
    <adx-tooltip v-if="tooltip" :text="tooltip" position="top" class="tooltip">
      <span slot="content">
        <div class="image">
          <img src="/img/icons/ic-info-color-@3x 2.png" alt="">
        </div>
      </span>
    </adx-tooltip>
    <button v-if="button" class="btn-small small-font secondary" @click.stop="buttonClicked" >{{button}}</button>
    <label :class="['subhead', frontIcon ? 'shift': '']">{{label}}</label>
    <p v-if="validationError" class="msg-error small-font">{{message}}</p>
  </div>
</template>

<script>
import * as validationLib from '@/lib/validation/'
import Tooltip from '@/components/Tooltip'
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-form-input',
  components: {
    'adx-tooltip': Tooltip
  },
  props: {
    label: {
      required: false
    },
    value: {
      required: false
    },
    error: {
      required: false
    },
    icon: {
      required: false
    },
    frontIcon: {
      required: false
    },
    button: {
      required: false
    },
    type: {
      required: false
    },
    validation: {
      required: false
    },
    validationMethod: {
      required: false,
      default: `onBlur`
    },
    disabled: {
      required: false,
      default: false
    },
    isInitial: {
      required: false
    },
    readonly: {
      required: false
    },
    inputId: {
      required: false,
      default: ''
    },
    upperCase: {
      required: false,
      default: false
    },
    tooltip: {
      required: false
    }
  },
  data() {
    return {
      initial: true,
      inputValue: undefined,
      valid: undefined,
      message: undefined
    }
  },
  mounted() {
    this.$data.inputValue = this.value
    if (!this.validation) {
      this.$emit(`update:isInitial`, false)
    }
  },
  methods: {
    getInput(value) {
      this.validateInput(value)
    },
    buttonClicked() {
      this.$emit(`buttonClicked`)
    },
    validateInput(value) {
      if (this.validation) {
        const { valid, message } = validate(this.validation, value, this.label)
        if(valid) {
          this.$emit(`update:value`, value)
          this.$emit(`update:error`, false)
        } else {
          // this.$emit(`update:value`, ``)
          this.$emit(`update:error`, !valid)
        }
        this.valid = valid
        this.message = message
      } else {
        this.$emit(`update:value`, value)
        this.$emit(`update:error`, false)
      }
      this.$emit(`uodatedValue`, value)
      this.$emit(`update:isInitial`, false)
    }
  },
  watch: {
    inputValue: helpers.debounce(function() {
      if(this.validationMethod === `onChange`) {
        if (!this.initial) {
          this.validateInput(this.inputValue)
        } else {
          this.initial = false
        }
      }
    }, 500),
    value: function () {
      this.inputValue = this.value
    },
    error: function () {
      if (typeof(this.error) == 'string') {
        this.message = this.error
      }
    }
  },
  computed: {
    validationError: function () {
      if (this.error) return this.error
      return this.valid === undefined ? false : !this.valid
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';

</style>